/* eslint-disable import/prefer-default-export */
import styled from 'styled-components'

import { PrimaryWrapper as BaseButton } from 'components/Button/Button.style'
import theme from 'styles/theme'

export const Wrapper = styled.div`
  padding-bottom: 1px;
  width: 100%;
  overflow: hidden;
  overflow-x: auto;
  text-align: center;
`

export const ListWrapper = styled.ol`
  margin: 0;
  padding: 0;
  list-style: none;
  white-space: nowrap;
`

export const Button = styled(BaseButton)`
  padding: ${theme.space[2]} ${theme.space[4]};
  border: 0;

  ${theme.mediaQueries.medium} {
    padding: ${theme.space[1]} ${theme.space[2]};
  }
`
